const getPrices = (orderLineItem) => {
  const lineItemOriginalPrice = orderLineItem.price?.total.subtotal ?? 0;
  const totalPaid = orderLineItem.price?.total.gross ?? 0;
  const discount = orderLineItem.price?.total.discount?.amount ?? 0;
  return {
    originalPrice: lineItemOriginalPrice,
    discountPrice: discount,
    price: totalPaid ?? lineItemOriginalPrice ?? 0
  };
};
export {
  getPrices
};
//# sourceMappingURL=get-prices.js.map
